import { render, staticRenderFns } from "./stationed_auth_add.vue?vue&type=template&id=37ce35f6"
import script from "./stationed_auth_add.vue?vue&type=script&lang=js"
export * from "./stationed_auth_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports